import APIClient from '@/clients/_helpers/client'
import URLs from '@/clients/_urls'

class InvoiceUploadAPI extends APIClient {
  async get(token, params) {
    const payload = {
      url: URLs.INVOICE_UPLOAD,
      method: 'GET',
      params: params,
      headers: {
        Authorization: token,
      },
    }
    try {
      const response = await this.sendRequest(payload)
      if ('error' in response.data) {
        throw new Error(response.data.error)
      }
      return response.data
    } catch (err) {
      throw this.createResponseRrror(err)
    }
  }
}
export default new InvoiceUploadAPI()
